<template>
  <div>
    <div v-if="loading">
      <div class="text-center">
        <b-spinner small variant="primary" type="grow" label="Spinning" />
        <b-spinner small variant="primary" type="grow" label="Spinning" />
        <b-spinner small variant="primary" type="grow" label="Spinning" />
      </div>
    </div>
    <div v-else>
      <div v-if="participants != null && participants.length === 0">
        <b-row class="align-center">
          <b-col><i>Aucune liste de résidents</i></b-col>
        </b-row>
      </div>
      <div v-else>
        <b-button
          v-b-toggle="'list-invisible-participant'"
          class="m-1"
          variant="info">
            <span class="when-open"><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span>
            <span class="when-closed"><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span>
            {{$t('label.list_resident')}}
          </b-button>
        <b-collapse id="list-invisible-participant">
          <b-row>
            <b-col>
              <b-form-group
                label="Filtrer"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                label-for="filterInput"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Taper pour rechercher un membre"
                  />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Effacer</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-table
            :fields="fields"
            :items="participants"
            :filter="filter"
            :filter-included-fields="filterOn"
            small
            responsive="sm"
            :tbody-tr-class="rowClass"
          >
            <template #cell(pare_is_delete)="row">
               <b-col  v-if="row.item.pare_is_delete">
                  <font-awesome-icon :icon="['fas', 'times']" class='deleted' />
               </b-col>
            </template>
            <template #cell(gender)="row">
              <b-col v-if="row.item.par_is_male"
                ><font-awesome-icon :icon="['fas', 'mars']" class="male"
              /></b-col>
              <b-col v-else
                ><font-awesome-icon :icon="['fas', 'venus']" class="female"
              /></b-col>
            </template>
            <template #cell(name)="row">
              <b-col
                >{{ row.item.par_lastname.toUpperCase() }} {{ row.item.par_firstname }}</b-col
              >
            </template>
            <template #cell(consent)="row">
              <b-col>
                <b-badge v-if="row.item.pare_consent" variant="success"
                  >oui</b-badge
                >
                <b-badge v-else variant="danger">non</b-badge>
              </b-col>
            </template>
            <template #cell(birthday)="row">
              <b-col v-if="row.item.birthday != null">{{
                row.item.birthday
              }}</b-col>
              <b-col v-else><i>Indéfinie</i></b-col>
            </template>
            <template #cell(pare_is_enable)="row">
              <b-badge :variant="row.item.pare_is_enable ? 'success' : 'danger'" >
                {{ row.item.pare_is_enable ? 'Actif' : 'Inactif' }}
              </b-badge>
            </template>

            <template #cell(update)="row">
              <b-row>
                <b-col
                  ><b-button
                    v-b-modal="'modal-update-participant-' + row.item.par_id"
                    size="sm"
                    variant="primary"
                    >Modifier</b-button
                  ></b-col
                >
                <b-modal
                  ref="modal_part"
                  :id="'modal-update-participant-' + row.item.par_id"
                  title="Modifier un participant"
                  scrollable
                  hide-footer
                  :no-close-on-backdrop="true"
                >
                  <form-participant
                    :esta="id"
                    :id="row.item.par_id"
                    @sendForm="receiveUpdate"
                    @sendCancel="receiveCancel"
                  />
                </b-modal>
                <b-col
                  ><b-button
                    v-b-modal="'modal-troubleshoot-' + row.item.par_id"
                    size="sm"
                    variant="outline-warning"
                    >Dépanner</b-button
                  ></b-col
                >
                <modal-troubleshoot
                  :esta_id="id"
                  :full="false"
                  :target="'modal-troubleshoot-' + row.item.par_id"
                  :id="row.item.par_id"
                  :devices="devices"
                  :label="row.item.par_lastname + ' ' + row.item.par_firstname"
                  type="par"
                />
              </b-row>
            </template>
          </b-table>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import FormParticipant from "../forms/FormParticipant.vue";
import ModalTroubleshoot from "../ModalTroubleshoot.vue";
import {formatStringDate} from '../../misc/utils';
import { getParticipantsForEstablishment, updateParticipant } from "../../services/participants";

export default {
  name: "ListParticipants",
  components: {
    FormParticipant,
    ModalTroubleshoot,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
    devices: {
      type: Array,
      default: null,
    }
  },
  data() {
    return {
      title: "List Participants",
      fields: [
        {
          pare_is_delete: {
            label: 'Supprimé',
            sortable: true,
            tdClass: 'align-middle',
          },
        },        
        {
          gender: {
            label: "Genre",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          name: {
            label: "Nom",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          birthday: {
            label: "Date de naissance",
            sortable: true,
            tdClass: "align-middle",
            filterByFormatted: true,
          },
        },
        {
          pare_is_enable: {
            label: 'Actif',
            sortable: true,
            tdClass: 'align-middle',
          },
        },        
        {
          consent: {
            label: "Consentement",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          update: {
            label: "Actions",
            sortable: false,
            tdClass: "align-middle",
          },
        },
      ],
      filter: null,
      filterOn: [],
      loading: true,
      participants: null
    };
  },
  async mounted() {
    this.getparticipants();
    this.setLoaded();
  },
  methods: {
    hideEdit() {
      this.$refs['modal_part'].hide();
    },
    receiveCancel(parId) {
      this.hideEdit();
    },
    receiveUpdate(formParticipant) {
      this.hideEdit();
      this.setparticipant(formParticipant);
      this.setLoaded();
    },
    setLoaded() {
      this.loading = false;
    },
    async getparticipants(){
      const data = await getParticipantsForEstablishment(this.id);
      if (data) {
        this.participants = data.map( (p) => {
          p.birthday = formatStringDate(p.par_birthday);
          return p;
        })
      }
    },
    async setparticipant(participant){
      const val = await updateParticipant(this.id, JSON.parse(participant));
      if (val) await this.getparticipants();
    },
    rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.pare_is_delete === true) return 'gosted'
      }
  },
};
</script>
<style>
.deleted {
  font-size: 20px;
  color: rgb(92, 16, 16);
}
.male {
  font-size: 20px;
  color: #17a2bf;
}
.female {
  font-size: 20px;
  color: hotpink;
}
.gosted {
  color: grey;
  background-color: lightgray;
}
</style>
